var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div',{attrs:{"id":"WebPage"}},[_c('app-header'),_c('app-header-mobile'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{attrs:{"id":"Content","params":"route: route"}})],1),_c('app-footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }